'use strict';

var _slicedToArray = require('babel-runtime/helpers/sliced-to-array')['default'];

var _WeakMap = require('babel-runtime/core-js/weak-map')['default'];

var _Number$isNaN = require('babel-runtime/core-js/number/is-nan')['default'];

var _getIterator = require('babel-runtime/core-js/get-iterator')['default'];

var _Object$assign = require('babel-runtime/core-js/object/assign')['default'];

var _Map = require('babel-runtime/core-js/map')['default'];

var Easing = require('easing-js');
var now = require('performance-now');
var raf = require('raf');

var privates = new _WeakMap();

function isNumber(obj) {
  return typeof obj === 'number' && !_Number$isNaN(obj);
}

function strip(number) {
  return parseFloat(number.toPrecision(12));
}

function someAnimating(animations) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(animations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2);

      var animation = _step$value[1];

      if (animation.isAnimating) return true;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

function scheduleAnimation(context) {
  raf(function () {
    var animations = privates.get(context);
    var currentTime = now();
    var shouldUpdate = false;
    animations.forEach(function (animation, name) {
      var isFunction = typeof name === 'function';
      if (!animation.isAnimating) return;

      var duration = animation.duration;
      var easing = animation.easing;
      var endValue = animation.endValue;
      var startTime = animation.startTime;
      var startValue = animation.startValue;

      var deltaTime = currentTime - startTime;
      if (deltaTime >= duration) {
        _Object$assign(animation, { isAnimating: false, startTime: currentTime, value: endValue });
      } else {
        animation.value = strip(Easing[easing](deltaTime, startValue, endValue - startValue, duration));
      }

      shouldUpdate = shouldUpdate || !isFunction;
      if (isFunction) name(animation.value);
    });

    if (shouldUpdate) context.forceUpdate();
    if (someAnimating(animations)) scheduleAnimation(context);
  });
}

var AnimationMixin = {
  componentWillUnmount: function componentWillUnmount() {
    privates['delete'](this);
  },

  shouldAnimate: function shouldAnimate() {
    return true;
  },

  animate: function animate(name, endValue, duration) {
    var options = arguments[3] === undefined ? {} : arguments[3];

    var animations = privates.get(this);
    if (!animations) {
      privates.set(this, animations = new _Map());
    }

    var animation = animations.get(name);
    var shouldAnimate = this.shouldAnimate() && options.animation !== false;
    if (!animation || !shouldAnimate || !isNumber(endValue)) {
      var easing = options.easing || 'linear';
      var startValue = isNumber(options.startValue) && shouldAnimate ? options.startValue : endValue;
      animation = { duration: duration, easing: easing, endValue: endValue, isAnimating: false, startValue: startValue, value: startValue };
      animations.set(name, animation);
    }

    if (animation.value !== endValue && !animation.isAnimating) {
      if (!someAnimating(animations)) scheduleAnimation(this);
      var startTime = 'startTime' in options ? options.startTime : now();
      _Object$assign(animation, { isAnimating: true, endValue: endValue, startValue: animation.value, startTime: startTime });
    }

    return animation.value;
  }
};

module.exports = AnimationMixin;


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/~/pui-react-animation/animation_mixin.js
 ** module id = 274
 ** module chunks = 0
 **/